module.exports = __webpack_public_path__ + "static/img/ic_filter_on@2x.a393df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_filter_on@2x.png
// module id = S7nm
// module chunks = 1